export const getElementName = (flowElementId, call) => {
    let title = '';
    call.flow.every((flowStep) => {
        if (flowStep.id === flowElementId) {
            title = flowStep.title;
            return false;
        }
        return flowStep.flow.every((flowForm) => {
            if (flowForm.id === flowElementId) {
                title = flowForm.title;
                return false;
            }
            return flowForm.flow.every((flowElement) => {
                if (flowElement.id === flowElementId) {
                    title = flowElement.title;
                    return false;
                }
                const groupField = flowElement.flow?.find((field) => field.id === flowElementId);
                if (groupField)
                    title = groupField.title;
                return !groupField;
            });
        });
    });
    return title;
};
